import React, { useEffect, useState } from "react";
import { CirclePower } from "lucide-react";
import { SyncBadge } from "../../common/badges";

const OnOffDetail1Widget = ({ widget, onValueUpdate, pattern }) => {
  const [isOn, setIsOn] = useState(false);
  const [v0, setV0] = useState();

  useEffect(() => {
    setV0(widget);
    if (widget?.items?.$w1) {
      if (widget.items.$w1.value === "on") {
        setIsOn(true);
      } else {
        setIsOn(false);
      }
    }
    return () => {};
  }, [widget]);

  const handleValueUpdate = (data) => {
    const updatedWidget = {
      ...v0.items.$w1,
      value: data ? "on" : "off",
    };
    onValueUpdate(updatedWidget);
  };

  const handleToggle = () => {
    if (pattern && pattern.endsWith("_R")) return;
    const newValue = !isOn;
    setIsOn(newValue);
    handleValueUpdate(newValue);
  };

  const disabled = pattern && pattern.endsWith("_R");

  return (
    <div className="w-full flex flex-col gap-4">
      {pattern && pattern.endsWith("_W") && (
        <div className="flex justify-end">
          <SyncBadge />
        </div>
      )}

      {/* On/Off Card */}
      <div
        className="rounded-2xl px-3 py-1.5 flex items-center justify-between"
        style={{
          height: "40px",
          backgroundColor: isOn ? "#FFD700" : "#B0B0B0",
          opacity: isOn ? 1 : 0.3,
        }}
      >
        <span className="text-white font-bold">{isOn ? "ON" : "OFF"}</span>
        <div
          className="h-8 aspect-square flex items-center justify-center flex-shrink-0"
          style={{
            cursor: disabled ? "default" : "pointer",
            opacity: disabled ? 0.8 : 1,
          }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleToggle();
          }}
        >
          <CirclePower
            size="100%"
            color="#FFFFFF"
            fill="#FFFFFF"
            opacity={isOn ? 1 : 0.3}
            fillOpacity={0.2}
            strokeWidth={2}
            style={{
              width: "100%",
              height: "100%",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default OnOffDetail1Widget;
